import { render, staticRenderFns } from "./SectionConfigDisplay.vue?vue&type=template&id=7f274a39"
import script from "./SectionConfigDisplay.vue?vue&type=script&lang=js"
export * from "./SectionConfigDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports